import axios from 'axios';
import { UploadFileRequest } from '../../types/interfaces/file';
import { SessionStore } from '../../types/store/SessionStore';
import { newAbortSignal } from '../../utils';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/files`;

export const uploadFile = async (
  uploadInfo: UploadFileRequest
): Promise<any> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const formData = new FormData();
  formData.append('entityId', uploadInfo.entityId.toString());

  if (uploadInfo.flowTestId) {
    formData.append('captureId', uploadInfo.captureId!.toString());
    formData.append('flowTestId', uploadInfo.flowTestId.toString());
  } else if (uploadInfo.managementUnitId) {
    formData.append('managementUnitId', uploadInfo.managementUnitId.toString());
  } else if (uploadInfo.captureId) {
    formData.append('captureId', uploadInfo.captureId.toString());
  }

  formData.append('fileContent', uploadInfo.file);
    
  const res = await axios.post<any>(BASE_URL, formData, {
    headers: {
      "content-type": "multipart/form-data",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};